// extracted by mini-css-extract-plugin
export var burgerButton = "header-module--burgerButton--61fff";
export var closeButton = "header-module--closeButton--8e114";
export var div = "header-module--div--30557";
export var divider = "header-module--divider--96bdc";
export var dropDown = "header-module--dropDown--56522";
export var icon = "header-module--icon--45fb6";
export var link = "header-module--link--134a5";
export var logo = "header-module--logo--46f4e";
export var mobileItem = "header-module--mobileItem--180dc";
export var mobileMenu = "header-module--mobileMenu--386be";
export var segment = "header-module--segment--feb77";
export var text = "header-module--text--e84c7";